module.exports = __webpack_public_path__ + "static/media/python.c8ac85a8.png";